// "Our Farmers" home section — horizontal carousel.
// Same pattern as recipes-carousel.js: prev/next buttons scroll by one
// viewport width with native smooth scrolling. Disables the buttons at
// the start / end of the track. RTL-safe because we compute against
// scrollLeft sign which the browser flips automatically in dir=rtl.

(function () {
    function init() {
        document.querySelectorAll('.home-farmers').forEach(setup);
    }

    function setup(section) {
        const viewport = section.querySelector('[data-farmers-viewport]');
        const prev     = section.querySelector('[data-farmers-prev]');
        const next     = section.querySelector('[data-farmers-next]');
        if (!viewport) return;

        const update = () => {
            const isRTL = getComputedStyle(viewport).direction === 'rtl';
            const max = viewport.scrollWidth - viewport.clientWidth - 2;
            const abs = Math.abs(viewport.scrollLeft);
            if (prev) prev.disabled = abs <= 2;
            if (next) next.disabled = abs >= max;
        };

        const step = () => viewport.clientWidth * 0.9;

        if (prev) prev.addEventListener('click', () => {
            const isRTL = getComputedStyle(viewport).direction === 'rtl';
            viewport.scrollBy({ left: isRTL ? step() : -step(), behavior: 'smooth' });
        });
        if (next) next.addEventListener('click', () => {
            const isRTL = getComputedStyle(viewport).direction === 'rtl';
            viewport.scrollBy({ left: isRTL ? -step() : step(), behavior: 'smooth' });
        });

        viewport.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
